import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "userAvatar", "userName", "messages", "input", "search", "list", "chatItem"];

  connect() {
    // Auto-open chat if query params provided (from Matches page)
    const params = new URLSearchParams(window.location.search);
    const userId = params.get('user_id');
    const avatar = params.get('avatar');
    const name = params.get('name');
    if (userId && (avatar || name)) {
      this.openChatDetail({ params: { userId, avatar, name } });
    }
  }

  openChat(event) {
    // Optionally use data attributes for user id
    this.showPage('chats');
  }

  openChatDetail(event) {
    const userId = event.params.userId;
    const avatar = event.params.avatar || '';
    const name = event.params.name || '';

    if (this.hasUserAvatarTarget) this.userAvatarTarget.src = avatar;
    if (this.hasUserNameTarget) this.userNameTarget.textContent = name;
    if (this.hasModalTarget) this.modalTarget.classList.add('active');
  }

  closeChatDetail() {
    if (this.hasModalTarget) this.modalTarget.classList.remove('active');
  }

  sendMessage() {
    if (!this.hasInputTarget || !this.hasMessagesTarget) return;
    const value = this.inputTarget.value.trim();
    if (!value) return;

    const messageEl = document.createElement('div');
    messageEl.className = 'message sent';
    messageEl.innerHTML = `
      <div class="message-content">
        <p>${value}</p>
        <span class="message-time">${new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
      </div>
    `;
    this.messagesTarget.appendChild(messageEl);
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight;
    this.inputTarget.value = '';

    setTimeout(() => {
      const responseEl = document.createElement('div');
      responseEl.className = 'message received';
      responseEl.innerHTML = `
        <div class="message-content">
          <p>Thanks for the message! 😊</p>
          <span class="message-time">${new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
        </div>
      `;
      this.messagesTarget.appendChild(responseEl);
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight;
    }, 2000);
  }

  // Placeholder: replace with your actual navigation logic if needed
  showPage(_page) {}

  filterChats() {
    if (!this.hasSearchTarget || !this.hasChatItemTarget) return;
    const term = this.searchTarget.value.toLowerCase();
    const items = Array.from(this.chatItemTargets);
    items.forEach(item => {
      const name = (item.dataset.name || '').toLowerCase();
      const lastMessage = item.querySelector('.last-message')?.textContent.toLowerCase() || '';
      const matches = name.includes(term) || lastMessage.includes(term);
      item.style.display = matches ? '' : 'none';
    });

    // Optional: bring matches to top while preserving order
    if (term) {
      const visible = items.filter(i => i.style.display !== 'none');
      const hidden = items.filter(i => i.style.display === 'none');
      visible.concat(hidden).forEach(el => this.listTarget.appendChild(el));
    }
  }
}


